// extracted by mini-css-extract-plugin
export default {"balanceOperation":"BalanceManager_balanceOperation__y44xE","amountInput":"BalanceManager_amountInput__OsUfh"};